import React from "react"
import { useStore } from "../../../stores/RootStoreContext"
import { ClientReplenishmentList } from "../../client/replenishment/ClientReplenishmentList"
import { ManagerReplenishmentList } from "../../manager/replenishment/ManagerReplenishmentList"

export const ReplenishmentList = () => {
  const { userStore } = useStore()

  if (userStore.isClient) {
    return <ClientReplenishmentList />
  } else if (userStore.isManager || userStore.isAdmin) {
    return <ManagerReplenishmentList />
  } else {
    return <></>
  }
}
